import React from 'react'
import styles from './DeliveryItem.module.css'
import loader from '../images/loading.gif'

type DeliveryItemT = {
  id: string,
  displayName: string,
  active: boolean,
  onSelect: (e: React.ChangeEvent<HTMLInputElement>) => void
  price: number
  loading: boolean
  messages?: string[]
}


function DeliveryItem ({
  id,
  displayName,
  active,
  onSelect,
  price,
  loading,
  messages = []
}: DeliveryItemT) {
  function handleClick () {
    onSelect({ target: { value: id } } as React.ChangeEvent<HTMLInputElement>)
  }

  return (
    <div className={`${styles.deliveryOption} ${active ? styles.selectedDeliveryOption : ''}`} onClick={handleClick}>
      <div className={styles.textContainer}>
        <label id={`optionDetails-${id}`} htmlFor={`deliveryOption-${id}`} >
          <p className={styles.optionName}>{displayName}</p>
        </label>
        {messages && messages.map((message, index) => <p key={index} aria-describedby={`optionDetails-${id}`} className={styles.deliveryOptionMessage}>{message}</p>)}
        <p className={styles.optionPrice}>{price} kr</p>
      </div>
      <button type={'button'} className={loading ? styles.loadingItemButton : active ? styles.selectedItemButton : styles.itemButton}>{loading ? <img style={{ maxHeight: '1.5rem' }} src={loader} alt="Loading..." /> : active ? 'Vald' : 'Välj'}</button>
      <input type='radio' name='deliveryOption' onChange={onSelect} value={id} id={`deliveryOption-${id}`} key={id} style={{ display: 'none' }} />
    </div>
  )
}

export default DeliveryItem